module.exports = __webpack_public_path__ + "img/save-icon.d32afc6d.svg";